module.exports = __webpack_public_path__ + "static/media/sms.2b43e5b3.svg";